
export const getVoucher = () => {
    const URL = `https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1//voucher`;
    return URL  
  }

  export const redeemVoucher = () => {
    const URL = `https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfo`;
    return URL  
  }
  

  export const getDeliveryInfos = () => {
    const URL = `https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfos`;
    return URL  
  }

  export const getDeliveryInfosByDate = () => {
    const URL = `https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfos`;
    return URL  
  } 

  export const updateDeliveryDetails = () => {
    const URL = `https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfo/update`;
    return URL;
  }

  export const updateVoucher = () => {
    const URL = `https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/voucherInfo/update`;
    return URL;
  }

  export const getAllVouchers = () => {
    const URL = 'https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/vouchers';
    return URL;
  }

//   POST - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/voucher
//   GET - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfo/{deliveryInfo}
//   POST - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfo
//   GET - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/vouchers
//   PUT - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfo/update
//   GET - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfos
//   GET - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/deliveryInfos/{start}/{end}
//   PUT - https://yn0iaaar6b.execute-api.eu-west-1.amazonaws.com/v1/voucherInfo/update
// functions:
//   getVoucherInfo: voltexAbsaSMEVoucher-v1-getVoucherInfo
//   getDeliveryInfo: voltexAbsaSMEVoucher-v1-getDeliveryInfo
//   createDeliveryInfo: voltexAbsaSMEVoucher-v1-createDeliveryInfo
//   getAllVoucher: voltexAbsaSMEVoucher-v1-getAllVoucher
//   updateDeliveryInfo: voltexAbsaSMEVoucher-v1-updateDeliveryInfo
//   findAllDeliveryInfo: voltexAbsaSMEVoucher-v1-findAllDeliveryInfo
//   findDeliveryInfoByDate: voltexAbsaSMEVoucher-v1-findDeliveryInfoByDate
//   updateVoucherInfo: voltexAbsaSMEVoucher-v1-updateVoucherInfo